import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { drawerManageColumnsSearchAtom } from "@ryde/shared";

import { ITableSettingsDrawerState } from "../table-settings.models";
import { filterManageColumnsData } from "./manage-columns.helpers";

export const useTableSettingsSearch = (
  state: ITableSettingsDrawerState<object>,
) => {
  const drawerManageColumnsSearchText = useRecoilValue(
    drawerManageColumnsSearchAtom,
  );

  const { activeColumns = [], inactiveColumns = [] } = useMemo(() => {
    if (!drawerManageColumnsSearchText?.trim()) {
      return state;
    }

    return filterManageColumnsData(state, drawerManageColumnsSearchText);
  }, [drawerManageColumnsSearchText, state]);

  return { activeColumns, inactiveColumns };
};
